import {pub, sub} from './pubsub.js'

function showEditSession(sessAndPath) {
    pub("showEditSession", sessAndPath)
}
function showEditSessionAddCallback(cb) {
    sub("showEditSession", cb)
}

function showSessionNew() {
    pub("showSessionNew")
}

function showSessionNewAddCallback(cb) {
    sub("showSessionNew", cb)
}

function showSessionList(ctrl) {
    pub("showSessionList", ctrl)
}

function showSessionListAddCallback(cb) {
    sub("showSessionList", cb)
}

function showImportSession() {
    pub("showImportSession")
}
function showImportSessionAddCallback(cb) {
    sub("showImportSession", cb)
}

function showKeys() {
    pub("showKeys")
}
function showKeysAddCallback(cb) {
    sub("showKeys", cb)
}

function hideTabsTopMenu() {
    pub("hideTabsTopMenu")
}

function hideTabsTopMenuAddCallback(cb) {
    sub("hideTabsTopMenu", cb)
}

function showSshKnownHosts() {
    pub("showSshKnownHosts")
}
function showSshKnownHostsAddCallback(cb) {
    sub("showSshKnownHosts", cb)
}

function showGuide() {
    pub("showGuide")
}
function showGuideAddCallback(cb) {
    sub("showGuide", cb)
}

function showAbout() {
    pub("showAbout")
}
function showAboutAddCallback(cb) {
    sub("showAbout", cb)
}

function setShowSessionsOnNewWindow(autoShow) {
    localStorage.setItem("showSessionsOnNewWindow", autoShow ? "true" : "false")
}
function getShowSessionsOnNewWindow() {
    if (localStorage.getItem("showSessionsOnNewWindow") === null) setShowSessionsOnNewWindow(true)
    return JSON.parse(localStorage.getItem("showSessionsOnNewWindow"))
}

function showOptions() {
    pub('showOptions')
}
function showOptionsAddCallback(cb) {
    sub('showOptions', cb)
}

function editingHotKey(combo) {
    pub('editingHotKey', combo)
}
function editingHotKeyAddCallback(cb) {
    sub('editingHotKey', cb)
}

// 退出快捷键编辑状态
function editingHotKeyCancel() {
    pub('editingHotKeyCancel')
}
function editingHotKeyCancelAddCallback(cb) {
    sub('editingHotKeyCancel', cb)
}

function showLogin() {
    pub('showLogin')
}
function showLoginAddCallback(cb) {
    sub('showLogin', cb)
}

function showCurTermSearch() {
    pub('showCurTermSearch')
}
function showCurTermSearchAddCallback(cb) {
    sub('showCurTermSearch', cb)
}

function showCurTermVimMode() {
    pub('showCurTermVimMode')
}
function showCurTermVimModeAddCallback(cb) {
    sub('showCurTermVimMode', cb)
}

// 版本更新相关的 UI 事件
// 安装包下载完成，回调参数是新版本信息
function showUpdateDownloaded() {
    console.log("ui pub showUpdateDownloaded")
    pub('showUpdateDownloaded')
}
function showUpdateDownloadedAddCallback(cb) {
    sub('showUpdateDownloaded', cb)
}

export default {
    showSessionNew,
    showSessionNewAddCallback,
    showSessionList,
    showSessionListAddCallback,
    showImportSession,
    showImportSessionAddCallback,
    hideTabsTopMenu,
    hideTabsTopMenuAddCallback,
    showEditSession,
    showEditSessionAddCallback,
    showKeys,
    showKeysAddCallback,
    showSshKnownHosts,
    showSshKnownHostsAddCallback,
    showGuide,
    showGuideAddCallback,
    showAbout,
    showAboutAddCallback,
    setShowSessionsOnNewWindow,
    getShowSessionsOnNewWindow,
    showOptions,
    showOptionsAddCallback,
    editingHotKey,
    editingHotKeyAddCallback,
    editingHotKeyCancel,
    editingHotKeyCancelAddCallback,
    showLogin,
    showLoginAddCallback,
    showCurTermSearch,
    showCurTermSearchAddCallback,
    showCurTermVimMode,
    showCurTermVimModeAddCallback,
    showUpdateDownloaded,
    showUpdateDownloadedAddCallback,
}
